import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { ReactNode } from "react";
import { DididerLIneCard, VectorIcon } from "../../assets/Icon/dashboredIcon";
import { LeftArrowBlue } from "../../assets/Icon/ArrowIcon";

interface DashboardCardProps {
  icon?: any;
  title?: string;
  btnTitle?: string;
  handleClick?: () => void;
  handleView?: () => void;
  isAdminCard?: boolean;
  totalNumber?: string;
}

const DashBoradCard: React.FC<DashboardCardProps> = (props) => {
  const {
    icon,
    title,
    btnTitle,
    handleClick,
    handleView,
    isAdminCard,
    totalNumber,
  } = props;

  return (
    <>
      <Card
        sx={{
          width: "100%",
          boxShadow: " 0px 2px 40px 0px #DDE3EA33",
          height: "172px ",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            right: 0,
          }}
        >
          <VectorIcon />
        </Box>
        <CardContent
          sx={{
            width: "100%",
            margin: "auto",
            padding: 3,
          }}
        >
          {!isAdminCard ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
              }}
            >
              {icon}
              <Typography
                gutterBottom
                sx={{
                  color: "#01060B",
                  fontSize: 18,
                  fontWeight: 600,
                  // whiteSpace: "nowrap",
                }}
              >
                {title}
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 1,
              }}
            >
              {icon}
              <Typography
                gutterBottom
                sx={{
                  color: " #6C6F71",
                  fontSize: 16,
                  fontWeight: 500,
                  // whiteSpace: "nowrap",
                }}
              >
                {title}
              </Typography>
              <Typography
                gutterBottom
                sx={{
                  color: "#01060B",
                  fontSize: 24,
                  fontWeight: 600,
                  // whiteSpace: "nowrap",
                }}
              >
                {totalNumber}
              </Typography>
            </Box>
          )}
          {!isAdminCard && <DididerLIneCard />}
          {!isAdminCard && (
            <CardActions
              sx={{ justifyContent: "space-between", marginTop: "10px" }}
            >
              <Button
                variant="contained"
                onClick={handleClick}
                sx={{
                  background:
                    btnTitle == "Completed"
                      ? "#3DC826"
                      : btnTitle == "Submitted"
                      ? "#2977CC"
                      : "#E7AB12",
                  width: 141,
                  borderRadius: "6px",
                  fontSize: "12px",
                  FontWeight: 600,
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                }}
              >
                {btnTitle}
              </Button>
              <Button
                size="small"
                onClick={handleView}
                sx={{ whiteSpace: "nowrap" }}
              >
                View Details <LeftArrowBlue />
              </Button>
            </CardActions>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default DashBoradCard;
